<template>
  <div class="block-wrapper" id="关于我们">
    <div class="container ">
      <div class="about_img">
        <img src="/images/banner3.png" />
      </div>

      <div class="about_cont">
        <h3>
          关于我们
        </h3>
        <p class="content">About us</p>
        <div class="content">
          <p class="indented-text">广东锐联科技有限公司是一家以信息技术咨询、信息系统集成、5G通信技术、技术开发为主导，集医疗器械、教学专用仪器、日用百货、办公用品、体育用材、各类设备销售批发等为一站式综合技术服务企业；公司拥有一批高级工程技术人才，具有较强的软件、硬件、结构设计开发及生产能力。企业致力于软件研发，同时紧紧围绕人性化多功能产品对教育信息化、政企服务进行多融合战略研究。</p>
          <p class="indented-text">丰富的从业经验,可根据客户的需求提供定制的解决方案。通过对市场的调查和分析，制订了符合市场发展需求的产品发展路线，力图依靠创新的设计理念、采用先进务实的技术构架、完整的解决方案和完善的服务成为一流的综合技术服务供应商。</p>
        </div>
        <a href="about.html" class="more" data-animate="bounceIn"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style lang="scss" scoped>
.block-wrapper {
  background: #f0f0f0;
  padding: 70px 0px;
  position: relative;
}
.container {
  width: 1310px;
  max-width: 100%;
  margin: 20px auto;
  display: flex;
  justify-content: space-around;

  .about_img {
    width: 30%;
    img {
      display: inline-block;
      width: 100%;
      padding-bottom: 20px;
      vertical-align: middle;
    }
  }
  .about_cont {
    display: flex;
    flex-direction: column;
    width: 50%;

    h3 {
      font-size: 24px;
      margin-top: 0px;
      margin-bottom: 0px;
      color: #444;
    }

    .content {
      padding: 0;
      color: #848484;
      background: none;
      font-size: 16px;
      line-height: 1.8;
      word-wrap: break-word;
      
      .indented-text {
        text-indent: 2em; 
      }
    }
  }
}
</style>
